import type { FilePreviewProps } from "../../types/FilePreviewerTypes";
import DOMPurify from "dompurify";

const VideoPreviewer = ({ url, ...restImageProps }: FilePreviewProps) => {
  const safeUrl = DOMPurify.sanitize(url);

  return (
    <video {...restImageProps} width="100%" height="450px" controls>
      <source src={safeUrl} />
    </video>
  );
};

export { VideoPreviewer };

VideoPreviewer.mimeTypes = ["video/mp4", "video/quicktime"];
